import * as XLSX from "xlsx";

/**
 * Exports an array of objects to an Excel (.xlsx) file.
 * @param {Array<Object>} data - Array of row objects where object keys represent column headers.
 * @param {string} fileName - File name without extension.
 * @param {string} [sheetName="Sheet1"] - Sheet name (up to 31 characters).
 */
export const exportToExcel = (data, fileName = "export", sheetName = "Sheet1") => {
    if (!data || !Array.isArray(data) || data.length === 0) {
        return;
    }

    const worksheet = XLSX.utils.json_to_sheet(data);

    // Auto-fit column widths based on maximum cell string length
    const colWidths = Object.keys(data[0] || {}).map((key) => {
        let maxLen = key.length;
        data.forEach((row) => {
            const val = row[key];
            if (val !== undefined && val !== null) {
                const len = String(val).length;
                if (len > maxLen) {
                    maxLen = len;
                }
            }
        });
        return { wch: Math.min(Math.max(maxLen + 4, 12), 50) };
    });
    worksheet["!cols"] = colWidths;

    const workbook = XLSX.utils.book_new();
    const sanitizedSheetName = (sheetName || "Sheet1").replace(/[:\\/?*\[\]]/g, "").substring(0, 31);
    XLSX.utils.book_append_sheet(workbook, worksheet, sanitizedSheetName);
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

export default exportToExcel;
